"use client"

import { Quote } from "lucide-react"

import { SectionContainer } from "@shared/ui/landing/section-container"

import { testimonialIds } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function TestimonialsSection() {
  const t = useTranslations("testimonials")

  return (
    <SectionContainer className="bg-brand-light/20">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        {testimonialIds.map((id) => (
          <div
            key={id}
            className="relative rounded-2xl border border-brand bg-white p-6 shadow-sm"
          >
            <Quote className="size-8 text-brand/20" />
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              &ldquo;{t(`${id}.quote`)}&rdquo;
            </p>
            <div className="mt-6 flex items-center gap-3">
              <div className="flex size-10 items-center justify-center rounded-full bg-brand/10 text-sm font-semibold text-brand">
                {t(`${id}.initials`)}
              </div>
              <div>
                <p className="text-sm font-semibold text-brand">{t(`${id}.name`)}</p>
                <p className="text-xs text-muted-foreground">{t(`${id}.role`)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </SectionContainer>
  )
}
